/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {ODataServiceFactory as ɵa} from './lib/services';